import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Logo } from "@/components/layout/Navbar";
import { EASE } from "@/lib/motion";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, password); nav("/admin"); }
    catch (err) { setError(formatApiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <main className="min-h-screen grid lg:grid-cols-2" data-testid="admin-login-page">
      <div className="hidden lg:block bg-[var(--ink)] text-[var(--cream)] p-14 relative grain">
        <Logo light className="!text-4xl relative z-[2]" />
        <div className="absolute bottom-14 left-14 right-14 z-[2]">
          <p className="eyebrow text-[var(--terracotta)]">Staff content management</p>
          <h1 className="font-display font-normal text-5xl mt-4 leading-[1.02]">Keep the range fresh — no developer required.</h1>
          <p className="mt-5 text-[var(--stone)] font-light max-w-md">Add brands, upload catalogues, flag new ranges, run promotions and update the homepage in minutes.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <motion.form onSubmit={submit} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: EASE }} className="w-full max-w-sm" data-testid="admin-login-form">
          <div className="lg:hidden mb-10"><Logo /></div>
          <p className="eyebrow text-[var(--muted)]">Deliver staff</p>
          <h2 className="font-display text-4xl mt-3 text-[var(--ink)]">Sign in</h2>
          <div className="mt-10 space-y-6">
            <input type="email" required data-testid="admin-email-input" className="input-line" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} />
            <input type="password" required data-testid="admin-password-input" className="input-line" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <p className="mt-4 text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
          <button disabled={busy} data-testid="admin-login-submit" className="btn-pill btn-ink mt-8 w-full justify-center disabled:opacity-60">{busy ? <Loader2 size={14} className="animate-spin" /> : "Sign in"}</button>
        </motion.form>
      </div>
    </main>
  );
}
